import { useEffect, useState } from 'react'
import TextField from '../Reusable/Form/TextInput'
import Select, { } from 'react-select'
import makeAnimated from 'react-select/animated';
import ColorField from '../Reusable/Form/ColorField';

const animatedComponents = makeAnimated();

const StatusForm = ({ register, errors, statusList, setValue, watch }: any) => {
  const [defaultValue, setDefaultValue] = useState()
  const onChange = (value: any) => {
    setValue("next_status", value)
    setDefaultValue(value)
  };

  useEffect(() => {
    if (!defaultValue) {
      setDefaultValue(watch("next_status"))
    }
  }, [watch("next_status")])


  return (
    <>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 mx-4">
        <TextField
          label={"Name"}
          register={register("name")}
          errors={errors?.name}
        />
        <ColorField
          label={"Color"}
          register={register("color")}
          errors={errors?.charge}
        />

      </div>
      <div className='mx-4 mt-4'>
        <label htmlFor="">Can Change Status To</label>
        <Select
          value={defaultValue}
          components={animatedComponents}
          closeMenuOnSelect={false}
          options={statusList}
          onChange={onChange}
          isMulti
        />
      </div>
    </>
  )
}

export default StatusForm
